import { render, staticRenderFns } from "./RegisterAgreement.vue?vue&type=template&id=3ad8d776&"
import script from "./RegisterAgreement.vue?vue&type=script&lang=ts&"
export * from "./RegisterAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports